(function() {
  'use strict';

  function loadImageTemplate(panel) {
    var template = panel.querySelector('template[data-image-id]');
    if (!template) return;
    var container = panel.querySelector('.custom-media-tabs__media-content');
    if (!container || container.querySelector('.custom-media-tabs__media-image')) return;
    container.insertAdjacentHTML('beforeend', template.innerHTML);
    template.remove();
  }

  function loadVideoTemplate(panel, allowVideo) {
    var template = panel.querySelector('template[data-video-id]');
    if (!template || !allowVideo) return;
    var videoContainer = panel.querySelector('.custom-media-tabs__media-content');
    if (!videoContainer || videoContainer.querySelector('video')) return;

    panel.setAttribute('data-loading', 'true');

    var existingPoster = videoContainer.querySelector('[data-video-poster]');
    if (existingPoster) existingPoster.remove();

    var videoUrl = template.getAttribute('data-video-url');
    var videoType = template.getAttribute('data-video-type') || 'video/mp4';
    var videoElement = template.querySelector('video');
    var videoAlt = videoElement ? videoElement.getAttribute('aria-label') : 'Video';

    var wrapper = document.createElement('div');
    wrapper.className = 'custom-media-tabs__media-video-wrapper';

    var video = document.createElement('video');
    video.className = 'custom-media-tabs__media-video';
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('muted', '');
    video.setAttribute('preload', 'auto');
    video.setAttribute('aria-label', videoAlt);

    var source = document.createElement('source');
    source.src = videoUrl;
    source.type = videoType;
    video.appendChild(source);

    var fallback = document.createTextNode('Your browser does not support the video tag.');
    video.appendChild(fallback);

    wrapper.appendChild(video);
    videoContainer.appendChild(wrapper);

    video.addEventListener('loadeddata', function() {
      panel.setAttribute('data-loading', 'false');
      video.muted = true;
      video.play().catch(function(err) {
        console.log('Video autoplay prevented:', err);
      });
    });

    video.muted = true;
    video.play().catch(function(err) {
      console.log('Video autoplay prevented:', err);
    });

    template.remove();
  }

  function loadPanelMedia(panel, allowVideo) {
    if (!panel) return;
    loadImageTemplate(panel);
    loadVideoTemplate(panel, allowVideo);
  }

  function initSection(sectionElement) {
    var tabButtons = sectionElement.querySelectorAll('.custom-media-tabs__tab-button');
    var mediaPanels = sectionElement.querySelectorAll('.custom-media-tabs__media-panel');
    if (!tabButtons.length || !mediaPanels.length) return;

    var tabsList = sectionElement.querySelector('.custom-media-tabs__tabs-list');
    var prevButton = sectionElement.querySelector('[data-direction="prev"]');
    var nextButton = sectionElement.querySelector('[data-direction="next"]');
    var paginationDots = sectionElement.querySelectorAll('.custom-media-tabs__pagination-dot');

    var currentIndex = parseInt(sectionElement.getAttribute('data-default-active'), 10);
    if (isNaN(currentIndex) || currentIndex < 0 || currentIndex >= tabButtons.length) {
      currentIndex = 0;
    }

    var isMobile = window.innerWidth < 990;
    var isTransitioning = false;
    var isInitialLoad = true;
    var userInteracted = false;

    function handleFirstInteraction() {
      if (userInteracted) return;
      userInteracted = true;
      loadPanelMedia(mediaPanels[currentIndex], true);
    }

    var interactionEvents = ['mouseover', 'keydown', 'touchstart', 'scroll'];
    for (var e = 0; e < interactionEvents.length; e++) {
      window.addEventListener(interactionEvents[e], handleFirstInteraction, { once: true, passive: true });
    }

    function updateActiveTab(index, shouldScroll) {
      if (shouldScroll === undefined) {
        shouldScroll = true;
      }
      if (isTransitioning || index < 0 || index >= tabButtons.length) return;

      isTransitioning = true;

      for (var i = 0; i < tabButtons.length; i++) {
        var isActive = i === index;
        tabButtons[i].setAttribute('aria-selected', isActive);
        tabButtons[i].classList.toggle('custom-media-tabs__tab-button--active', isActive);
      }

      for (var j = 0; j < mediaPanels.length; j++) {
        var panel = mediaPanels[j];
        var panelActive = j === index;
        panel.setAttribute('aria-hidden', !panelActive);

        if (panelActive) {
          loadPanelMedia(panel, userInteracted || !isInitialLoad);
        }

        var video = panel.querySelector('video');
        if (video) {
          if (panelActive) {
            video.muted = true;
            video.play().catch(function(err) {
              console.log('Video autoplay prevented:', err);
            });
          } else {
            video.pause();
            video.currentTime = 0;
          }
        }

        if (panelActive && panel.querySelector('template[data-model-id]')) {
          var modelTemplate = panel.querySelector('template[data-model-id]');
          var modelContainer = panel.querySelector('.custom-media-tabs__media-model');
          if (modelContainer && !modelContainer.querySelector('model-viewer')) {
            if (modelTemplate.hasAttribute('data-model-url')) {
              var modelUrl = modelTemplate.getAttribute('data-model-url');
              var modelElement = modelTemplate.querySelector('model-viewer');
              var modelAlt = modelElement ? modelElement.getAttribute('alt') : '3D Model';
              modelContainer.innerHTML =
                '<model-viewer ' +
                'src=\"' + modelUrl + '\" ' +
                'alt=\"' + modelAlt + '\" ' +
                'camera-controls ' +
                'touch-action=\"pan-y\" ' +
                'auto-rotate ' +
                'ar ' +
                'ar-modes=\"webxr scene-viewer quick-look\" ' +
                'loading=\"lazy\" ' +
                'style=\"width: 100%; height: 100%;\"' +
                '>' +
                '</model-viewer>';
            } else {
              modelContainer.innerHTML = modelTemplate.innerHTML;
            }
            modelTemplate.remove();
          }
        }
      }

      for (var d = 0; d < paginationDots.length; d++) {
        paginationDots[d].setAttribute('aria-current', d === index);
      }

      if (shouldScroll && !isInitialLoad && isMobile && tabsList) {
        var activeTab = tabButtons[index];
        if (activeTab && activeTab.scrollIntoView) {
          activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }

      if (prevButton) prevButton.disabled = index === 0;
      if (nextButton) nextButton.disabled = index === tabButtons.length - 1;

      currentIndex = index;

      setTimeout(function() {
        isTransitioning = false;
      }, 400);
    }

    for (var b = 0; b < tabButtons.length; b++) {
      (function(button, index) {
        button.addEventListener('click', function() {
          updateActiveTab(index);
        });

        button.addEventListener('keydown', function(e) {
          if (isMobile) return;

          var newIndex = currentIndex;
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            newIndex = (currentIndex + 1) % tabButtons.length;
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            newIndex = currentIndex === 0 ? tabButtons.length - 1 : currentIndex - 1;
          } else if (e.key === 'Home') {
            e.preventDefault();
            newIndex = 0;
          } else if (e.key === 'End') {
            e.preventDefault();
            newIndex = tabButtons.length - 1;
          }

          if (newIndex !== currentIndex) {
            updateActiveTab(newIndex);
            tabButtons[newIndex].focus();
          }
        });
      })(tabButtons[b], b);
    }

    if (prevButton) {
      prevButton.addEventListener('click', function() {
        if (currentIndex > 0) {
          updateActiveTab(currentIndex - 1);
        }
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function() {
        if (currentIndex < tabButtons.length - 1) {
          updateActiveTab(currentIndex + 1);
        }
      });
    }

    for (var p = 0; p < paginationDots.length; p++) {
      (function(dot, index) {
        dot.addEventListener('click', function() {
          updateActiveTab(index);
        });
      })(paginationDots[p], p);
    }

    function handleResize() {
      var wasMobile = isMobile;
      isMobile = window.innerWidth < 990;

      if (wasMobile && !isMobile) {
        updateActiveTab(currentIndex, false);
      }
    }

    window.addEventListener('resize', handleResize);

    updateActiveTab(currentIndex, false);

    setTimeout(function() {
      isInitialLoad = false;
    }, 100);

    setTimeout(function() {
      var activePanel = mediaPanels[currentIndex];
      if (!userInteracted && activePanel) {
        var autoTemplate = activePanel.querySelector('template[data-video-id][data-video-autoload=\"true\"]');
        if (autoTemplate) {
          loadPanelMedia(activePanel, true);
        }
      }
    }, 8000);
  }

  function initAllSections() {
    var sections = document.querySelectorAll('.custom-media-tabs');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }
})();
